// extracted by css-extract-rspack-plugin
export default {"TenantNameInput":"DSe2b"};